import React from "react";
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { Form, Input, Button, Row, Col } from "antd";
import BgLeft from "../../../assets/images/bg-left.png";
import BgRight from "../../../assets/images/bg-right.png";
import { ReactComponent as PasswordHide } from "../../../assets/icons/password-hidden.svg";
import { ReactComponent as PasswordShow } from "../../../assets/icons/password-show.svg";
import Validator from "../../../utils/formValidator";
import { GASignUpClickToLogin, GASignUpClickToPrivacy, GASignUpClickToService, GASignUpClickConfirm } from "../../../ga/signUp";

import "../../../assets/signUp.scss";

const SignUpRender = ({ captchaObj, submitLoading, urlSearch, handleRequestSignUp, handleRequsetGetCode }) => {
  const { t } = useTranslation(["loginAndSignUp", "common"]);

  /**
   * 自定义密码显示和隐藏icon
   * @param {*} visible
   */
  const passWordIconRender = visible => (visible ? <PasswordShow /> : <PasswordHide />);

  const [form] = Form.useForm();

  const handleOnEmailChange = e => {
    /**
     * 监听email值发生变化时，去执行以下confirm email
     */
    let confirmEmailValue = form.getFieldValue("comfirmEmail");
    if (confirmEmailValue) {
      form.validateFields(["comfirmEmail"]);
    }
  };

  return (
    <div className="signUp-page-cont position-relative">
      <div className="signUp-page-bg position-absolute top-0 left-0 w-100 d-flex justify-content-between overflow-hidden">
        <img className="d-lg-block d-none" src={BgLeft} alt="bg" />
        <img className="d-lg-block d-none" src={BgRight} alt="bg" />
      </div>
      <div className="container mx-auto d-flex flex-column align-items-center justify-content-center">
        <h2 className="fw-bold mb-3">{t("common:signUp")}</h2>
        <p className="mb-2 pb-4 text-center">
          <Trans i18nKey="loginAndSignUp:loginTips">
            Text
            <Link className="ms-2" to={`/login${urlSearch}`} onClick={GASignUpClickToLogin}>
              Link
            </Link>
          </Trans>
        </p>
        <Form form={form} name="signUp" className="w-100" onFinish={handleRequestSignUp} validateTrigger="onBlur">
          <Form.Item
            name="email"
            label=""
            rules={[
              {
                required: true,
                formName: "signUp",
                validator: Validator.emailValidator,
              },
            ]}
          >
            <Input placeholder={t("common:email")} onChange={handleOnEmailChange} autoComplete="off" />
          </Form.Item>
          <Form.Item
            name="comfirmEmail"
            label=""
            rules={[
              {
                required: true,
                formName: "signUp",
                validator: async (rule, value) => Validator.emailSameValidator(rule, value, form.getFieldValue("email")),
              },
            ]}
          >
            <Input placeholder={t("common:confirmEmail")} autoComplete="off" />
          </Form.Item>
          <Form.Item
            name="password"
            label=""
            rules={[
              {
                required: true,
                formName: "signUp",
                validator: Validator.passwordValidator,
              },
            ]}
          >
            <Input.Password placeholder={t("common:password")} iconRender={passWordIconRender} autoComplete="off" autoComplete="new-password" />
          </Form.Item>
          <Form.Item name="verificaiton" label="" rules={[{ required: true, formName: "signUp", validator: Validator.emptyValidator }]}>
            <Row gutter={8}>
              <Col span={16}>
                <Input placeholder={t("common:verificationCode")} />
              </Col>
              <Col span={8}>
                <span className="bg-light w-100 d-block" style={{ height: 48, borderRadius: 4, cursor: "pointer" }} onClick={handleRequsetGetCode}>
                  {captchaObj.captchaBase64 ? <img className="mw-100" src={captchaObj.captchaBase64} alt="code" /> : null}
                </span>
              </Col>
            </Row>
          </Form.Item>
          <p className="mb-4">
            <Trans i18nKey="loginAndSignUp:signUpPrivacyTips">
              Text
              <Link className="text-primary" to="/services-policy" onClick={GASignUpClickToService} target="_blank">
                Link
              </Link>
              Text
              <Link className="text-primary" to="/privacy-policy" onClick={GASignUpClickToPrivacy} target="_blank">
                Link
              </Link>
            </Trans>
          </p>
          <Form.Item>
            <Button className="w-100 fw-bolder" type="primary" htmlType="submit" size="large" loading={submitLoading} onClick={GASignUpClickConfirm}>
              {t("common:signUp")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default SignUpRender;
